exports = module.exports = require("../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-knowledge-rate {\n  position: absolute;\n  bottom: 0;\n  right: -40px; }\n  .m-knowledge-rate .button {\n    display: block;\n    background: #fff;\n    width: 32px;\n    height: 32px;\n    border-radius: 32px;\n    text-align: center;\n    line-height: 32px;\n    font-size: 17px;\n    margin-top: 6px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader?{}!./node_modules/_sass-loader@4.0.2@sass-loader?{"sourceMap":true}!./node_modules/_postcss-loader@1.3.3@postcss-loader?{"sourceMap":true}!./src/app/extension/knowledgerate/style.scss
// module id = 250
// module chunks = 0 1